import {Image} from '../index';

export enum typeLayout {
  left = 'left',
  right = 'right',
  center = 'center'
}

export enum typeSize {
  o = 'original',
  s = 'small',
  m = 'medium',
  l = 'large'
}

export interface Layout {
  position: typeLayout;
}

/**
 * Tail souhaitée à l'affichage
 * 0 : taille originale
 */
export interface Size {
  size: typeSize;
}

export interface ImageValue {
  imageId: number;
  layout: Layout;
  size: Size;
  file: string;
}

export interface ImageBlock {
  type: 'image';
  value: ImageValue;
}
